<template>
  <div class="list">
    <div class="header">
      <div class="l">
        <div class="label">
          状态
        </div>
        <el-select
          v-model="searchForm.isBought"
          placeholder="请选择状态"
          filterable
          clearable
          @change="getList()"
        >
          <el-option
            v-for="item in isBoughtList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <div class="label">
          省市区
        </div>
        <el-cascader
          v-model="cascaderInfo"
          :props="cascaderProps"
          :options="province"
          clearable
          @change="formatCity"
        />
      </div>
      <div class="r">
        <el-select
          v-model="studentSearchType"
          class="input-select"
          placeholder="请选择状态"
          filterable
          @change="clearSearchValue"
        >
          <el-option
            v-for="item in studentSearchList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-input
          v-model="searchForm[studentSearchType]"
          :placeholder="placeholder[studentSearchType]"
          @keyup.enter.native="getList()"
        >
          <el-button
            slot="append"
            type="primary"
            @click="getList()"
          >
            搜索
          </el-button>
        </el-input>
        <el-link
          :href="downloadUrl"
          target="_blank"
        >
          <el-button
            type="primary"
          >
            导出学员
          </el-button>
        </el-link>
      </div>
    </div>
    <data-table
      :data="tabelData"
      :table-column="tableColumn"
      :pagination="true"
      @changeBypagination="tableHandle"
      @sortChange="sortChange"
      @buttonClick="buttonClick"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axClient from '@/services';
import dataTable from '@/components/common/dataTable.vue';
import types, { isBoughtList, studentSearchList } from '@/config';

const config = require('../../../httpConfig');

export default {
  name: 'Home',
  components: {
    dataTable,
  },
  data() {
    return {
      cascaderProps: {
        value: 'id',
        label: 'name',
        children: 'sonList',
      },
      isBoughtList, // 是否购买下拉
      studentSearchList, // 搜索字段
      cascaderInfo: '', // 省市区
      tabelData: {},
      studentSearchType: 'realName',
      placeholder: {
        realName: '请输入学员姓名',
        mobilePhone: '请输入学员手机号',
        idCard: '请输入学员身份证',
      },
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        idCard: '',
        isBought: '', // 是否购买
        sortType: null,
        provinceId: '',
        mobilePhone: '',
        cityId: '',
        areaId: '',
      },
      tableColumn: [
        {
          key: 'realName',
          label: '学员姓名',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'mobilePhone',
          label: '学员电话',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'provinceCityAreaName',
          label: '省市区',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'address',
          label: '详细地址',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'boughtCourseAmount',
          label: '支付总金额',
          width: '80px',
          dataType: 'money',
        },
        {
          key: 'totalRefundCourseAmount',
          label: '退款总金额',
          width: '80px',
          dataType: 'money',
        },
        {
          key: 'boughtCourseCount',
          label: '课程总数',
          width: '80px',
          dataType: 'text',
        },
        {
          key: 'isBought',
          label: '是否购买',
          width: '80px',
          dataType: 'component',
          renderProps: { [types.IS_STUDENT_BUY]: '是', [types.IS_STUDENT_NO_BUY]: '否', successKey: types.IS_STUDENT_BUY },
          render: () => 'status',
        },
        {
          key: 'isAgent',
          label: '是否代理商人员',
          width: '80px',
          dataType: 'component',
          renderProps: { 1: '是', 0: '否', successKey: 1 },
          render: () => 'status',
        },
        {
          key: 'isAgency',
          label: '是否机构人员',
          width: '80px',
          dataType: 'component',
          renderProps: { 1: '是', 0: '否', successKey: 1 },
          render: () => 'status',
        },
        {
          key: 'idCard',
          label: '身份证号',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'createTime',
          label: '创建时间',
          width: 'auto',
          dataType: 'time',
          sortable: 'custom',
        },
        {
          key: 'control',
          label: '操作',
          width: '70px',
          dataType: 'component',
          renderProps: [
            {
              text: '查看', renderKey: null, type: 'info', eventIndex: 0, disableKey: null,
            },
          ],
          render: () => 'buttons',
        },
      ],
    };
  },
  computed: {
    ...mapGetters(['province', 'user']),
    downloadUrl() {
      let query1 = '';
      let query2 = '';
      let query3 = '';
      let query4 = '';
      let query5 = '';
      if (this.searchForm.idCard) {
        query1 = `idCard=${this.searchForm.idCard}`;
      }
      if (this.searchForm.mobilePhone) {
        query2 = `&courseChapterId=${this.searchForm.mobilePhone}`;
      }
      if (this.searchForm.realName) {
        query3 = `&courseChapterId=${this.searchForm.realName}`;
      }
      if (this.searchForm.isBought) {
        query4 = `&isBought=${this.searchForm.isBought}`;
      }
      if (this.searchForm.provinceId) {
        query5 = `&provinceId=${this.searchForm.provinceId}&cityId=${this.searchForm.cityId}&areaId=${this.searchForm.areaId}`;
      }
      return `${process.env.VUE_APP_HOST_ENV === 'dev' ? config.dev : config.prod}/api/user/pageStudentExport?${query1}${query2}${query3}${query4}${query5}`;
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 切换下拉 清除选项的值
    clearSearchValue() {
      this.searchForm.idCard = '';
      this.searchForm.mobilePhone = '';
      this.searchForm.realName = '';
    },
    // 获取列表
    async getList(num = 1) {
      this.searchForm.pageNum = num;
      const result = await axClient.student.getList(this.searchForm);
      const { pageNum, pageSize, total } = result;
      result.list.forEach((item) => {
        this.$set(item, 'isAgency', item.agencyId ? 1 : 0);
        this.$set(item, 'isAgent', item.agentId ? 1 : 0);
      });
      this.tabelData = {
        pageNum,
        pageSize,
        total,
        list: result.list,
      };
    },
    // 跳转到详情
    goDetails(item) {
      this.$router.push({ name: 'StudentDetails', params: { id: item.userId } });
    },
    // table 传递过来的按钮点击
    buttonClick(type, item) {
      switch (type) {
        case 0:
          this.goDetails(item);
          break;
        default:
          break;
      }
    },
    // table 改变 pagination 时间
    tableHandle(pageNum, pageSize) {
      this.searchForm.pageNum = pageNum;
      this.searchForm.pageSize = pageSize;
      this.getList(pageNum);
    },
    // table sortChange
    sortChange(data) {
      const { prop, order } = data;
      const sortType = {
        courseRegistrationCount: {
          ascending: 10,
          descending: 20,
        },
        createTime: {
          ascending: 30,
          descending: 40,
        },
      };
      this.searchForm.sortType = sortType[prop][order];
      this.getList();
    },
    // 处理省市区
    formatCity(item) {
      const [provinceId, cityId, areaId] = item;
      this.searchForm = Object.assign(this.searchForm, { provinceId, cityId, areaId });
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
